import dark from "./dark";
import light from "./light";
export default {
  dark: false,
  options: {
    customProperties: true,
  },
  themes: {
    dark,
    light,
  },
};
